var map = {
	"./TypesChs.js": [
		2506,
		[
			506
		]
	],
	"./TypesCht.js": [
		2899,
		[
			899
		]
	],
	"./TypesEn.js": [
		2403,
		[
			403
		]
	],
	"./TypesEs.js": [
		7176,
		[
			176
		]
	],
	"./TypesEsLa.js": [
		2243,
		[
			243
		]
	],
	"./TypesFre.js": [
		5793,
		[
			793
		]
	],
	"./TypesGer.js": [
		352,
		[
			352
		]
	],
	"./TypesIta.js": [
		1478,
		[
			478
		]
	],
	"./TypesJpn.js": [
		2134,
		[
			134
		]
	],
	"./TypesKor.js": [
		9822,
		[
			822
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5870;
module.exports = webpackAsyncContext;